import { appendAPExamTemplate } from '@/functions/idp'

import RIC from './RIC_5'

export default appendAPExamTemplate({
  ...RIC,
  aimName: 'RIC+AP'
})
